/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as utils from '@daas-consulting/core-frontend-utils';
import { AgeGroupsService } from '@daas-consulting/production/age_groups/frontend/data_contracts';
import * as models from '@daas-consulting/production/age_groups/frontend/models';
import {
  Configuration,
  ConfigurationId,
} from '@daas-consulting/production/shared/cross/configuration';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpAgeGroupsService implements AgeGroupsService {
  readonly #baseUrl: string;
  readonly #http!: HttpClient;

  constructor(
    http: HttpClient,
    @Inject(ConfigurationId) configuration: Configuration
  ) {
    this.#http = http;
    this.#baseUrl = `${configuration.baseUrl}/age-groups`;
  }

  getAll$(): Observable<models.list.ItemView[]> {
    const url = `${this.#baseUrl}/list`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rv = this.#http
      .get<models.list.ItemView[]>(url)
      .pipe(utils.rxjs.retryWhenNot401(3));
    return rv;
  }
}
